import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "recompose";
import { Chart } from "react-google-charts";

import { withLocale, InjectedLocaleProps } from "@localisation/components/withLocale";
import { MusicIdProps, getSalesByCountry } from "../../selectors";
import { SalesState } from "../../models";
import { messages } from "../../messages";

interface GeoSalesChartStateProps {
    data: Array<Array<number | string>>;
}

type Props = GeoSalesChartStateProps & MusicIdProps & InjectedLocaleProps;

const GeoSalesChart = ({ data, locale }: Props) => (
    <div className="geo-sales-chart">
        <h3 className="display-3">
            <FormattedMessage {...messages.geoChartTitle} />
        </h3>
        <div className="geo-sales-chart__wrap"><div>
            <Chart
                chartType="GeoChart"
                data={data}
                graph_id="geo-sales-chart"
                width="100%"
                height="100%"
                options={{
                    tooltip: {isHtml: true},
                    colorAxis: {colors: ["#02B4EC"]},
                }}
                chartLanguage={locale}
                chartVersion="current"
                />
        </div></div>
    </div>
);

const mapStateToProps = (state: SalesState, props: MusicIdProps) => {
    return {
        data: getSalesByCountry(state, props),
    } as GeoSalesChartStateProps;
};

// TODO Connect to the API
const ConnectedGeoSalesChart = compose<Props, MusicIdProps>(
    injectIntl,
    withLocale,
    connect(mapStateToProps, null),
)(GeoSalesChart);

export {
    GeoSalesChart as GeoSalesChartPresenter,
    ConnectedGeoSalesChart as GeoSalesChart,
};
